export const ADD_REPORT = "@report/ADD_REPORT";
export const REMOVE_REPORT = "@report/REMOVE_REPORT";
export const UPDATE_REPORT = "@report/UPDATE_REPORT";
export const DELETE_REPORT = "@report/DELETE_REPORT";
export const IS_LOADING_REPORT = "@report/IS_LOADING_REPORT";
export const MAKE_REPORT = "@report/MAKE_REPORT";
export const GET_REPORT = "@report/GET_REPORT";
export const FETCH_REPORT = "@report/FETCH_REPORT";
export const FETCH_GROUPORDER_DOWNLOAD = "@report/FETCH_GROUPORDER_DOWNLOAD";
export const FAILED_GROUPORDER_PDF = "@report/FAILED_GROUPORDER_PDF";
